import { POST_INFO_TALENT_START } from '../../types';

export const post_info_talent = (payload) => ({
  type: POST_INFO_TALENT_START,
  payload,
});
